import { CouponCurrency } from '@/@types/Coupons';

/** As únicas moedas que um cupom aceita, na ordem em que aparecem na tela. */
export const COUPON_CURRENCIES: CouponCurrency[] = ['BRL', 'USD'];

/** Ofertas fora de BRL e USD não entram no cupom; contam como BRL. */
export function normalizeCouponCurrency(
  currency: string | null | undefined
): CouponCurrency {
  return currency === 'USD' ? 'USD' : 'BRL';
}

/** Moeda do cupom vinda da API; `null` se ausente ou fora de BRL/USD. */
export function couponCurrencyFromApi(
  currency: string | null | undefined
): CouponCurrency | null {
  return COUPON_CURRENCIES.includes(currency as CouponCurrency)
    ? (currency as CouponCurrency)
    : null;
}

/** A outra moeda do par que o cupom aceita. */
export function otherCouponCurrency(currency: CouponCurrency): CouponCurrency {
  return currency === 'USD' ? 'BRL' : 'USD';
}

/**
 * Moedas das ofertas marcadas, na ordem da tela (BRL primeiro). Lista vazia =
 * todas as ofertas; `null` = nenhuma marcada, então nenhuma moeda.
 */
export function couponScopeCurrencies(
  offerIds: string[] | null,
  offers: { id: string; currency: string | null | undefined }[]
): CouponCurrency[] {
  if (offerIds === null) {
    return [];
  }

  const inScope =
    offerIds.length === 0
      ? offers
      : offers.filter((offer) => offerIds.includes(offer.id));
  const currencies = new Set(
    inScope.map((offer) => normalizeCouponCurrency(offer.currency))
  );

  return COUPON_CURRENCIES.filter((currency) => currencies.has(currency));
}

/**
 * Converte centavos entre BRL e USD pela cotação "1 USD = `usdToBrl` BRL".
 * Só para exibição: o checkout converte de novo, na cotação do momento.
 */
export function convertCouponAmount(
  amountInCents: number,
  from: CouponCurrency,
  usdToBrl: number
): number {
  if (usdToBrl <= 0) {
    return 0;
  }

  return Math.round(
    from === 'USD' ? amountInCents * usdToBrl : amountInCents / usdToBrl
  );
}
